export default class PasswordValidationRule {
  public readonly PASSWORD_REGEX = /^(?=.{8,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/
  public readonly PASSWORD_REQUIRED = 'Password is required.'
  public readonly PASSWORD_LENGTH = 'Password must 8 characters or longer.'
  public readonly PASSWORD_CHARACTERS =
    'Password must include 3 of the following: a lower-case letter, upper-case letter, a number and a special character (&*^$!)'

  public passwordRules: Array<object> = [
    (v: string) => !!v || this.PASSWORD_REQUIRED,
    (v: string) => (v && v.length >= 8) || this.PASSWORD_LENGTH,
    (v: string) => this.PASSWORD_REGEX.test(v) || this.PASSWORD_CHARACTERS,
  ]

  constructor() {}
}
